export default __webpack_public_path__ + "static/media/razer-bg.569a1a18.jpg";